import { Dispatch } from '@reduxjs/toolkit';

import SessionClientDashboard from 'dashboard/lib/clients/SessionClientDashboard';
import { UserAuditLog } from 'dashboard/models/user-audit-log';
import {
  setUserAuditLogs,
  UserAuditLogsFilterParams,
} from 'dashboard/redux/actions/user-audit-logs';
import { ApiEndpoint, PaginationParams } from 'lib/interfaces/api';

export function loadUserAuditLogList({
  currentPage,
  pageSize,
  filters,
  abortSignal,
}: {
  currentPage: number;
  pageSize: number;
  filters: UserAuditLogsFilterParams;
  abortSignal?: AbortSignal;
}) {
  return async (dispatch: Dispatch) => {
    const paramsFull = {
      ...createParamsForUserAuditLogs(filters),
      page: {
        number: currentPage,
        size: pageSize,
      },
      signal: abortSignal,
    };

    const { data: userAuditLogs, meta: paginationParams } =
      await SessionClientDashboard.listResource<UserAuditLog, PaginationParams>(
        ApiEndpoint.UserAuditLog,
        paramsFull,
      );

    /* @ts-expect-error [strict-migration] The following line is not strict; please fix! */
    dispatch(setUserAuditLogs(userAuditLogs, paginationParams));
  };
}

function createParamsForUserAuditLogs(filters: UserAuditLogsFilterParams) {
  const { omni, methods, createdAtStart, createdAtEnd, userId } = filters;

  return {
    filter: {
      omni,
      methods,
      'created-at-start': createdAtStart && createdAtStart.toString(),
      'created-at-end': createdAtEnd && createdAtEnd.toString(),
      'user-id': userId,
    },
  };
}
